const formUserNewName = 'formUserNew';
const formUserEditName = 'formUserEdit';

const formAttributeEditorName = 'formAttributeEditor';

const PAGE_FORM = 'PAGE_FORM'; // contains home, create, edit
const PAGE_CONFIRM = 'PAGE_CONFIRM';

export { formUserNewName, formUserEditName, formAttributeEditorName, PAGE_CONFIRM, PAGE_FORM };
